import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './atoms/Icon';
import SessionManager from '../utils/sessionManager';
import { API_BASE_URL } from '../config';

const VerificationBanner = () => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkVerificationStatus();
  }, []);

  const checkVerificationStatus = async () => {
    try {
      // Use SessionManager to get candidate session
      const candidateSession = SessionManager.getSession('candidate');
      if (!candidateSession || !candidateSession.user_id) {
        setLoading(false);
        return;
      }

      const userId = candidateSession.user_id;
      const token = candidateSession.access_token;

      const response = await fetch(`${API_BASE_URL}/verification/status/${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setIsVerified(data.verified);
        
        // Show banner if not verified and not dismissed
        const dismissed = localStorage.getItem('verification_banner_dismissed');
        if (!data.verified && !dismissed) {
          setShowBanner(true);
        }
      }
    } catch (error) {
      console.error('Error checking verification status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyNow = () => {
    navigate('/verification-welcome');
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('verification_banner_dismissed', 'true');
  };

  if (loading || !showBanner || isVerified) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3 flex-1">
            <Icon name="verified_user" size={24} className="text-white hidden sm:block" />
            <div className="flex-1">
              <p className="font-semibold text-sm sm:text-base">
                Complete profile verification to increase visibility to recruiters by 3x
              </p>
              <p className="text-xs sm:text-sm text-blue-100 mt-1">
                Stand out with a verified badge • Takes only 20-25 minutes
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={handleVerifyNow}
              className="bg-white text-blue-600 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-blue-50 transition-colors flex items-center gap-2"
            >
              <Icon name="play_arrow" size={18} />
              Verify Now
            </button>
            <button
              onClick={handleDismiss}
              className="text-white hover:text-blue-100 transition-colors"
              aria-label="Dismiss"
            >
              <Icon name="close" size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationBanner;
